import Pages from "../layouts/Pages/Pages.jsx";
import Dashboard from "../layouts/Dashboard/Dashboard.jsx";

var indexRoutes = [
  { path: "/login", name: "Pages", component: Pages },
  { path: "/dashboard", name: "Home", component: Dashboard },
  { path: "/", name: "Home", component: Dashboard },
  localStorage.getItem("id_customer_report") !== null
    ? {
        redirect: true,
        pathTo: "/dashboard",
        component: Dashboard,
        name: "Dashboard",
      }
    : {
        redirect: true,
        pathTo: "/login",
        name: "Login",
        component: Pages,
      },
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx